<div class="overlay">
  <div class="modal" style="width: 100%; height: 100%; ">
    <div class="modal-content">
      <div class="flex justify-content-between flex-wrap" style="
          padding-top: 15px;
          padding-bottom: 16px;
          padding-right: 2px;
          padding-left: 70px;
          border-bottom: 1px solid #f2f4f7;
        ">
        <div class="img">
          <div class="flex justify-content-start flex-wrap">
            <div class="flex align-items-center justify-content-center mr-1">
              <img src="assets/image/auto-e-care-logo.png" alt="Logo" class="svg-black" />
            </div>
            <!-- <div class="flex align-items-center justify-content-center">
              <p style="color: #1d2939; font-weight: 700; font-size: 18px">
                Auto ECare
              </p>
            </div> -->
          </div>
        </div>
        <!-- <div class="flex align-items-center justify-content-center">
          <p style="font-weight: 700; color: #333; font-size: 24px">
            {{ editMode ? 'Update Service Seeker Form' : 'Add Service Seeker Form' }}
          </p>
        </div> -->
        <div class="flex justify-content-center flex-wrap align-items-center"> 
          <div class=" cross-icon">
             <i class="pi pi-times" style="cursor: pointer; font-size: 1em; top: 0;" (click)="close()"></i>
           </div>
        </div>   
      </div>
      <div class="flex" style="height: calc(100vh - 70px); ">
        <div class="sidebar" style="margin-top: 62px">
          <ul>
            <li>
              <a (click)="setActiveSection('map-location')" [ngClass]="{
                  active: activeSection === 'map-location'
                }">
                <i class="pi pi-map-marker"></i>Location
              </a>
            </li>
            <li>
              <a (click)="setActiveSection('address-proof')" [ngClass]="{ active: activeSection === 'address-proof' }">
                <i class="pi pi-file-plus"></i>Address-proof
              </a>
            </li>
            <li>
              <a (click)="setActiveSection('personal-details')"
                [ngClass]="{ active: activeSection === 'personal-details' }">
                <i class="pi pi-user"></i>Customer Details
              </a>
            </li>

            <!-- Always show Upload RTO -->
            <li>
              <a *ngIf="countryId == 2; else uploadRTO" (click)="setActiveSection('upload-section')"
                [ngClass]="{ active: activeSection === 'upload-section' }">
                <i class="pi pi-cloud-upload"></i>Upload Mulkiya
              </a>
              <ng-template #uploadRTO>
                <a (click)="setActiveSection('upload-section')"
                  [ngClass]="{ active: activeSection === 'upload-section' }">
                  <i class="pi pi-cloud-upload"></i>Upload RTO
                </a>
              </ng-template>
            </li>

            <li>
              <a (click)="setActiveSection('vehicle-details')"
                [ngClass]="{ active: activeSection === 'vehicle-details' }">
                <i class="pi pi-list"></i> Vehicle Details
              </a>
            </li>

            <li>
              <a (click)="setActiveSection('tyre-battery-details')"
                [ngClass]="{ active: activeSection === 'tyre-battery-details' }">
                <i class="pi pi-list"></i> Tyre, Battery & Engine Oil Details
              </a>
            </li>

            <!-- Always show Insurance Details -->
            <li>
              <a (click)="setActiveSection('insurance-details')"
                [ngClass]="{ active: activeSection === 'insurance-details' }">
                <i class="pi pi-shield"></i>Insurance Details
              </a>
            </li>
          </ul>
        </div>
        <div class="content" style="flex-grow: 1;" [ngClass]="{'no-scroll': activeSection === 'map-location'}">
          <app-map-location *ngIf="activeSection ==='map-location'" (nextSection)="setActiveSection('address-proof')"
            [formSource]="'User'" [formStateService]="userFormstate"></app-map-location>
          <app-addressproof *ngIf="activeSection === 'address-proof'"
            (nextSection)="setActiveSection('personal-details')" [formSource]="'User'"
            [formStateService]="userFormstate"></app-addressproof>

          <app-user-personal-detail *ngIf="activeSection === 'personal-details'"
            (nextSection)="setActiveSection('upload-section')"></app-user-personal-detail>

          <app-upload-documents *ngIf="activeSection === 'upload-section'"
            (nextSection)="setActiveSection('vehicle-details')"></app-upload-documents>

          <app-add-vehicle-details *ngIf="activeSection === 'vehicle-details'"
            (nextSection)="setActiveSection('tyre-battery-details')"></app-add-vehicle-details>

          <app-add-tyre-battery-details *ngIf="activeSection === 'tyre-battery-details'"
            (nextSection)="setActiveSection('insurance-details')"></app-add-tyre-battery-details>

          <app-add-insurance-details (close)="close()" (updateUserList)="onUpdateUserList()"
            *ngIf="activeSection === 'insurance-details'"></app-add-insurance-details>
        </div>
      </div>
    </div>
  </div>
</div>